import { Select } from '@99designs/common/components/Select';
import { FormattedMessage } from '@99designs/common/i18n';
import { Field } from 'common/components/Form';
import GenerativeAiTooltip from 'launch/components/GenerativeAiTooltip';
import Link from 'launch/components/Link';
import React from 'react';
import { intlShape } from 'react-intl';

interface Props {
    onChange: Function;
    errorMessage: string | null;
    value: string;
}

export default class GenerativeAiPreferenceField extends React.Component<Props> {
    static contextTypes = {
        intl: intlShape.isRequired,
    };

    static defaultProps = {
        errorMessage: null,
    };

    get aiArticleUrl() {
        const { locale } = this.context.intl;
        return `https://support.99designs.com/hc/${locale}/articles/28799753445012`;
    }

    render() {
        return (
            <Field
                htmlFor="allowGenerativeAi"
                title={
                    <span>
                        {__('Allow the use of AI-generated design in your contest?')} *
                        <GenerativeAiTooltip />
                    </span>
                }
                message={
                    <FormattedMessage
                        message={__(
                            'If you allow generative AI to be included in your design, please be aware this could have implications with regard to intellectual property rights in your design. {ai_article_link}'
                        )}
                        values={{
                            ai_article_link: (
                                <Link href={this.aiArticleUrl} target={'_blank'}>
                                    {__('Learn more')}
                                </Link>
                            ),
                        }}
                    />
                }
                errorMessage={this.props.errorMessage}
            >
                <Select
                    id="allowGenerativeAi"
                    onChange={({ value }) => this.props.onChange(value)}
                    value={this.props.value}
                    options={[
                        { value: '', label: __('Select'), disabled: true },
                        {
                            value: 'yes',
                            label: __(
                                'Yes, I allow designers to use generative AI in their submissions.'
                            ),
                        },
                        {
                            value: 'no',
                            label: __(
                                'No, I do not allow designers to use generative AI in their submissions.'
                            ),
                        },
                    ]}
                />
            </Field>
        );
    }
}
